import { Input, Component, Output, EventEmitter, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import {LocalStorageService} from 'ngx-webstorage';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(private storage:LocalStorageService, private router: Router) { }

  ngOnInit() {
    this.storage.clear('agent');
    this.storage.clear('username');
    this.storage.clear('quoteId');
  }
  form: FormGroup = new FormGroup({
    username: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
  });

  submit() {
    if (this.form.valid) {
      const username = this.form.value.username;
      console.log(username);
      this.storage.store('username',username);
      if (username == 'jph'){
        this.storage.store('agent','jason-henson');
      } else{
        this.storage.store('agent','paul-potts');
      }
      this.router.navigateByUrl('home');
    }
  }
  @Input() error: string | null;

  @Output() submitEM = new EventEmitter();
}
